import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';
import styles from './Caret.scss';

const Caret = ({ isOpen }) => (
  <FaChevronDown className={classNames({[styles.open]: isOpen})} />
);

Caret.propTypes = {
  isOpen: PropTypes.bool
}

export default Caret;